// extracted by mini-css-extract-plugin
module.exports = {"button":"CatRandomCopyButton_button___hPRy","fa-random":"CatRandomCopyButton_fa-random__emZNn"};